import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_learn-16048_WEBINAR_GATING'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
